import pkg from '../../package.json' with { type: 'json' };
export const CB_KEYS_URL = 'https://keys.coinbase.com/connect';
export const CB_WALLET_RPC_URL = 'https://rpc.wallet.coinbase.com';
export const PACKAGE_NAME = pkg.name;
export const PACKAGE_VERSION = pkg.version;
//# sourceMappingURL=constants.js.map